SWR.Social.prototype._getTwitterParams = function _getTwitterParams(){
  var self = this;
  var data = {};

  // Twitter
  data.endpoint = 'https://publish.twitter.com/oembed';
  data.params = {
    'align': 'left',
    'theme': 'light',
    'hide_media': false,
    'video': true,
    'hide_thread': true,
    'omit_script': false
  };
  data.dataType = 'jsonp';

  return data;
};

SWR.Social.prototype._loadTwitterSDK = function _loadTwitterSDK() {
  if ('undefined' !== typeof window.twttr && 'undefined' !== typeof window.twttr.widgets) {
    try {
      window.twttr.widgets.load()
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e)
    }
    $('twitterwidget').each(function () {
      window.twttr.widgets.createTweet($(this).data('tweetId'), this.parentNode);
      this.parentNode.removeChild(this)
    });
  } else {
    window.twttr = (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {};
      if (d.getElementById(id))
        return t;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);
      t._e = [];
      t.ready = function (f) {
        t._e.push(f);
      };
      return t;
    }(document, "script", "twitter-wjs"));
    // Wait for the asynchronous resources to load
    window.twttr.ready(function (twttr) {
      twttr.events.bind(
        'loaded',
        function (event) {
          try {
            event.widgets.forEach(function (widget) {
              var links = widget.querySelectorAll('a');
              for (var link in links) {
                link.target = '_blank';
                link.rel = 'external noreferrer nofollow'
              }
            })
          } catch (e) {
            (console.error || console.log).call(console, e.stack || e)
          }
        }
      )
    });

  }
};
